import { render } from "./ClubCommitteeView.vue?vue&type=template&id=5eddc1a4"
import script from "./ClubCommitteeView.vue?vue&type=script&lang=js"
export * from "./ClubCommitteeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__